module.exports = __webpack_public_path__ + "static/media/no-activity-found.b501e9b7.svg";